import Vue from 'vue'
import VueRouter from 'vue-router'
import publicRoutes from './public'
import agentRoutes from './agent'
import adminRoutes from './admin'
import generalRoutes from './general'
import supervisorRoutes from './supervisor'
import customRoutes from './custom'
import userRoutes from './user'
import officeScreenRoutes from './officeScreen'

Vue.use(VueRouter)

const allRoutes = [
]
const routes = allRoutes.concat(
  publicRoutes,
  officeScreenRoutes,
  agentRoutes,
  adminRoutes,
  supervisorRoutes,
  customRoutes,
  userRoutes,
  // import general route last to avoid conflicts
  generalRoutes
)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
